// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"e6b0943c","228":"6705269b","276":"d75a5cc8","415":"0016ca33","656":"20d6415f","706":"5bcd3481","765":"54161c67","812":"7e12c307","863":"3fb72b09"}[chunkId] + ".chunk.css";
};